// extracted by mini-css-extract-plugin
module.exports = {"container":"_1RXTb_J-JHaxRH_hfdrpPC"};